import { ImsPermissions } from "@redotech/account-common/permissions";
import { useRequiredContext } from "@redotech/react-util/context";
import AiStarIcon from "@redotech/redo-icons/ai-star.svg";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo } from "react";
import { useLocation } from "react-router-dom";

export const IntelligentInventoryItem = memo(
  function IntelligentInventoryItem() {
    const routes = useRequiredContext(MerchantRoutesContext);
    const location = useLocation();
    const canAccessIntelligentInventory = useHasPermission(
      ImsPermissions.ACCESS_INTELLIGENT_INVENTORY,
    );

    const isSelected =
      location.pathname.includes("/intelligent-inventory/") ||
      location.pathname.endsWith("/intelligent-inventory");

    return (
      <RedoSecondaryNavItem
        action={{
          type: "link",
          href: `${routes.inventoryManagementBaseUrl}/intelligent-inventory`,
        }}
        beta
        FilledIcon={AiStarIcon}
        friendlyName="Intelligent inventory"
        hidden={!canAccessIntelligentInventory}
        id="intelligent-inventory"
        selected={isSelected}
        UnfilledIcon={AiStarIcon}
      />
    );
  },
);
